export const UPDATE_PDF_OVERLAY = 'UPDATE_PDF_OVERLAY';
export const SHOW_PDF_OVERLAY = 'SHOW_PDF_OVERLAY';
export const HIDE_PDF_OVERLAY = 'HIDE_PDF_OVERLAY';
export const CLEAR_PDF_OVERLAY = 'CLEAR_PDF_OVERLAY';
